import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import userSagas from './user/saga';
import locationSagas from './location/saga';
import accessSagas from './access/saga';
import userGroupSagas from './usergroup/saga';
import logSagas from './log/saga';
import dashboardSagas from './dashboard/saga';
export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    userSagas(),
    logSagas(),
    dashboardSagas(),
    locationSagas(),
    accessSagas(),
    userGroupSagas(),
  ]);
}
